<ion-content (touchstart)="onTouchStart($event)"
(touchmove)="onTouchMove($event)"
(touchend)="onTouchEnd($event)">
	<div class="wrapper">
		<div class="content">

			<header class="header">
				<img class="logo" src="assets/images/add-name/logo.svg" alt="Logo">
			</header>

			<div class="main">

				<div class="mr-potty">
					<img src="assets/images/add-name/mr_potty_without_arms.svg" alt="Mr Potty Image Without Arms">
				</div>
				<div class="arms">
					<img src="assets/images/add-name/left-arm.svg" alt="Mr Potty Arm">
					<img class="right-arm" src="assets/images/add-name/right-arm.svg" alt="Mr Potty Arm">
					<div class="bubble">
						<img src="assets/images/add-name/bubble.svg" alt="Bubble">
						<p class="bubble-text">Poo shy?</p>
					</div>
				</div>

				<div class="main-content">
					<h2 class="title">Give us your John Hancock?</h2>

					<app-progress-bar color="success" [activeStep]="activeStep"></app-progress-bar>

					<input [(ngModel)]="name" (ngModelChange)="determineContinueButtonStatus($event)"
						class="main-input" type="text" placeholder="E.g., Jane Doe, Captain Potty, The Queen">

					<div class="checkbox-block">
						<div class="custom-checkbox">
							<ion-checkbox [(ngModel)]="remainAnonymous" color="primary"
								(ngModelChange)="determineContinueButtonStatus($event)"></ion-checkbox>
							<ion-label (click)="setStatusForFormControlBasedOffAnonymousText()">Remain Anonymous</ion-label>
						</div>
						<img class="question" src="assets/images/add-name/question.svg" alt="Question Icon"
							(click)="showHint()">
					</div>
				</div>

				<div class="mr-toilet-block" *ngIf="showHintMessage">
					<div class="mr-toilet">
						<img src="assets/images/add-name/mr_toilet.svg" alt="Mr Toilet">
						<div class="reversed-bubble">
							<img src="assets/images/add-name/bubble-right.svg" alt="Reversed Bubble">
							<p class="reversed-bubble__text">Feel free to share your name; it will be visible to others as the author of the note.</p>
							<p></p>
						</div>
					</div>
				</div>

				<app-navigation-buttons
					(click)="saveNameMetadata($event);"
					[isNextButtonDisabled]="continueButtonDisabled"
					[isBackButtonHidden]="true"
					[isSkipButtonHidden]="true"
					[isStartOfNoteFlow]="true"
				></app-navigation-buttons>
				<div></div>
			</div>
		</div>
	</div>
</ion-content>
